import { useRef } from 'react';
import { Space, Table, Button,Input,Empty } from 'antd';
import type { TableProps } from 'antd';
import { DataType,column } from './column';
import { merchantList } from "@/services/merchant"
import useSearchTable from '@/hooks/useList';
import MerchantContent from './component/merchantDetail';
import MenuPermissionControl from '@/components/menuPermissionControl';
import useGetCurMenuId from '@/hooks/useGetCurMenuId';

export default function UsersPage() {
  const { menuId } = useGetCurMenuId();
  const dialog = useRef<any>(null);
  const defaultValue = {
    Name: '',
  }
  const {
    data,
    total,
    loading,
    fetchData,
    searchParams,
    handleSearch,
    handlePageChange
  } = useSearchTable(merchantList, defaultValue );
  
  const search = (e:any)=>{
    handleSearch({Name: e.target.value})
  }
  
  const columns: TableProps<DataType>['columns'] = [
    ...column,
    {
      title: '操作',
      key: 'action',
      render: (_, record) => (
        <Space size="middle">
          <MenuPermissionControl menuId={menuId} operation="edit" >
            <Button onClick={()=>{
              dialog.current.open('edit',record)
            }}>编辑</Button>
          </MenuPermissionControl>
        </Space>
      ),
    }
  ];


  return (
    <>
      
      <div className="headerTitle">
        <div>
          <h2 >商户管理</h2>
        </div>
      </div>

      <div className="card">
        <div className="mb-4 flex flex-col md:flex-row gap-4">
          <div className="searchCond">
            <Space size='middle'>
              <Input style={{ width:'250px' }} allowClear placeholder="商户名称" onPressEnter={search} size='large' onChange={search}/>
              
                <Button type="primary" size='large' onClick={()=>{ fetchData() }}>搜索</Button>
              
              <MenuPermissionControl menuId={menuId} operation="edit" >
                <Button type='primary' size='large' onClick={()=>{
                  dialog.current.open('add')          
                }}>新增商户</Button>
              </MenuPermissionControl>
            </Space>
          </div>
        </div>
            
        <Table
          rowKey='id'
         columns={columns} 
         dataSource={data as DataType[]}
         loading={loading}
         pagination={{ current: searchParams.PageIndex, pageSize:searchParams.PageSize, total, onChange: handlePageChange,showSizeChanger:false  }}
         scroll={{ x: 'max-content', y: 580 }}
         locale={{ emptyText: <Empty description="暂无数据"></Empty> }}
        />
       
      </div>
      <MerchantContent ref={dialog} save={handleSearch}/>
      </>
  );
} 